import LeadAllTabs from "./LeadAllTabs";
import { ClientProvider } from "../../context/ClientContext";

export default function LeadTabsWrapper(props) {
  return (
    <ClientProvider>
      <LeadAllTabs {...props} />
    </ClientProvider>
  );
}